import React, { Fragment } from "react";

import Default from "./Partials";

export default function Planscreen() {
	return (
		
			<Default />
			
	);
}
